module.exports = __webpack_public_path__ + "static/Employes-1ffec50807406bda5b8cde06faab3a9d.png";